import { render, staticRenderFns } from "./class-check.vue?vue&type=template&id=6ac86da4&scoped=true"
import script from "./class-check.vue?vue&type=script&lang=ts"
export * from "./class-check.vue?vue&type=script&lang=ts"
import style0 from "./class-check.vue?vue&type=style&index=0&id=6ac86da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac86da4",
  null
  
)

export default component.exports